import { Component } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { IWeissmanModalComponent } from 'src/app/Compliance/WeissmanModalService';

export interface PaymentApprovalActionModalParams {
    targetStatusId: number;
    targetStatusLabel: string;
    paymentCount: number;
}

export interface PaymentApprovalActionModalResult {
    comment: string | null;
}

@Component({
    selector: 'payment-approval-action-modal',
    templateUrl: './paymentApprovalActionModal.component.html',
    standalone: false,
})
export class PaymentApprovalActionModalComponent
    implements IWeissmanModalComponent<PaymentApprovalActionModalParams, PaymentApprovalActionModalResult>
{
    constructor(private readonly bsModalRef: BsModalRef) {}

    params: PaymentApprovalActionModalParams;
    result: PaymentApprovalActionModalResult;
    comment: string = '';
    commentTouched: boolean = false;

    get headerLabel(): string {
        const label = this.params.targetStatusLabel;
        const count = this.params.paymentCount;
        return `Mark ${count} ${count === 1 ? 'Payment' : 'Payments'} as ${label}`;
    }

    get isRejection(): boolean {
        return this.params.targetStatusId === Core.PaymentApprovalStatusEnum.Rejected;
    }

    get isCommentMissing(): boolean {
        return this.isRejection && !this.comment.trim();
    }

    get disableSave(): boolean {
        return this.isCommentMissing;
    }

    save(): void {
        this.commentTouched = true;
        if (this.disableSave) {
            return;
        }
        this.result = { comment: this.comment.trim() || null };
        this.bsModalRef.hide();
    }

    cancel(): void {
        this.bsModalRef.hide();
    }
}
